import { css } from '@emotion/css';

export const imageBorderStyles = css`
  box-shadow: 0 0 0 2px var(--bg-primary);
`;

export const collectionsImageBorderStyle = css`
  border: none !important;
`;
